/**
 * GUMYUM GUMMIES — THEME.JS
 * v2 — Proper Health animations: word-split, count-up, tilt, carousel, blur-up, scroll-progress
 */

document.addEventListener('DOMContentLoaded', () => {

  /* ================================================
     1. SCROLL PROGRESS BAR
  ================================================ */
  const progressBar = document.getElementById('scroll-progress');
  if (progressBar) {
    window.addEventListener('scroll', () => {
      const scrolled = window.scrollY;
      const total = document.documentElement.scrollHeight - window.innerHeight;
      progressBar.style.width = total > 0 ? (scrolled / total * 100) + '%' : '0%';
    }, { passive: true });
  }

  /* ================================================
     2. STICKY HEADER SHADOW
  ================================================ */
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 60);
    }, { passive: true });
  }

  /* ================================================
     3. SCROLL-TRIGGERED FADE-UP (IntersectionObserver)
  ================================================ */
  const fadeIO = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        fadeIO.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

  // Auto-apply fade-up to key section elements
  const fadeSelectors = [
    '.section-title', '.trust-badge', '.combo-card',
    '.testimonial-card', '.category-card', '.brand-story__text',
    '.brand-story__media', '.newsletter-section__inner'
  ];
  fadeSelectors.forEach(sel => {
    document.querySelectorAll(sel).forEach((el, i) => {
      el.classList.add('fade-up');
      el.style.transitionDelay = (i % 6 * 0.08) + 's';
      fadeIO.observe(el);
    });
  });

  // Observe all pre-classed fade-up elements and reveal-on-scroll
  document.querySelectorAll('.fade-up, .fade-in, .scale-in, .reveal-on-scroll').forEach(el => {
    if (!el.classList.contains('is-visible')) fadeIO.observe(el);
  });

  // Stagger product cards in carousels
  document.querySelectorAll('.products-carousel__track .product-card').forEach((card, i) => {
    card.classList.add('fade-up');
    card.style.transitionDelay = (i % 4 * 0.1) + 's';
    fadeIO.observe(card);
  });

  /* ================================================
     4. HERO WORD-SPLIT ANIMATION
  ================================================ */
  const heroTitle = document.querySelector('.hero-banner__title');
  if (heroTitle) {
    const words = heroTitle.innerText.trim().split(/\s+/);
    heroTitle.innerHTML = words.map(word =>
      `<span class="word-wrap"><span class="word-inner">${word}</span></span>`
    ).join(' ');

    // Trigger after slight delay for paint
    requestAnimationFrame(() => {
      setTimeout(() => {
        heroTitle.querySelectorAll('.word-inner').forEach((w, i) => {
          setTimeout(() => w.classList.add('is-visible'), i * 90);
        });
      }, 120);
    });

    // Also animate eyebrow and subtitle
    const eyebrow = document.querySelector('.hero-banner__eyebrow');
    const subtitle = document.querySelector('.hero-banner__subtitle');
    const actions = document.querySelector('.hero-banner__actions');
    [eyebrow, subtitle, actions].forEach((el, i) => {
      if (!el) return;
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity 0.7s ease, transform 0.7s cubic-bezier(0.16,1,0.3,1)';
      setTimeout(() => {
        el.style.opacity = '1';
        el.style.transform = 'translateY(0)';
      }, 400 + (words.length * 90) + (i * 120));
    });
  }

  /* ================================================
     5. ANNOUNCEMENT BAR — auto-dismiss
  ================================================ */
  const announcementBar = document.querySelector('.announcement-bar');
  const closeBtn = document.querySelector('.announcement-bar__close');
  if (closeBtn && announcementBar) {
    if (sessionStorage.getItem('announcementDismissed')) {
      announcementBar.style.display = 'none';
    }
    closeBtn.addEventListener('click', () => {
      announcementBar.style.maxHeight = announcementBar.offsetHeight + 'px';
      requestAnimationFrame(() => {
        announcementBar.style.transition = 'max-height 0.3s ease, opacity 0.3s ease';
        announcementBar.style.maxHeight = '0';
        announcementBar.style.opacity = '0';
        announcementBar.style.overflow = 'hidden';
        setTimeout(() => announcementBar.remove(), 350);
      });
      sessionStorage.setItem('announcementDismissed', '1');
    });
  }

  /* ================================================
     6. MOBILE MENU
  ================================================ */
  const menuBtn = document.querySelector('.header-menu-btn, .mobile-menu-btn');
  const mobileDrawer = document.querySelector('.mobile-nav-drawer');
  const mobileOverlay = document.querySelector('.mobile-nav-overlay');
  const mobileClose = document.querySelector('.mobile-nav-drawer__close');

  function openMobileMenu() {
    mobileDrawer?.classList.add('active');
    mobileOverlay?.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileMenu() {
    mobileDrawer?.classList.remove('active');
    mobileOverlay?.classList.remove('active');
    document.body.style.overflow = '';
  }

  menuBtn?.addEventListener('click', openMobileMenu);
  mobileClose?.addEventListener('click', closeMobileMenu);
  mobileOverlay?.addEventListener('click', closeMobileMenu);

  /* ================================================
     7. CART DRAWER
  ================================================ */
  const cartBtns = document.querySelectorAll('.header-cart-btn, [data-cart-trigger], [data-open-cart]');
  const cartDrawer = document.querySelector('.cart-drawer');
  const cartOverlay = document.querySelector('.cart-overlay');
  const cartClose = document.querySelector('.cart-drawer__close');

  function openCart() {
    cartDrawer?.classList.add('active');
    cartOverlay?.classList.add('active');
    document.body.style.overflow = 'hidden';
    loadCartContents();
  }
  // Open the drawer INSTANTLY without fetching — used by Add to Cart so the
  // panel + a loading state appear immediately; loadCartContents renders next.
  window.openCartShell = function () {
    cartDrawer?.classList.add('active');
    cartOverlay?.classList.add('active');
    document.body.style.overflow = 'hidden';
    var b = document.querySelector('.cart-drawer__body');
    if (b) b.innerHTML = '<div style="padding:64px 24px;text-align:center;color:#8a847b;font-size:14px;">Adding to your cart…</div>';
  };
  function closeCart() {
    cartDrawer?.classList.remove('active');
    cartOverlay?.classList.remove('active');
    document.body.style.overflow = '';
  }

  cartBtns.forEach(btn => btn.addEventListener('click', openCart));
  cartClose?.addEventListener('click', closeCart);
  cartOverlay?.addEventListener('click', closeCart);

  async function loadCartContents() {
    const body = document.querySelector('.cart-drawer__body');
    if (!body) return;
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      if (cart.item_count === 0) {
        body.innerHTML = `<div class="cart-drawer__empty">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>
            <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
          </svg>
          <p>Your cart is empty</p>
          <a href="/collections/all" class="btn btn--primary" style="margin-top:20px;">Shop Now</a>
        </div>`;
        updateCartCount(0);
        if (typeof window.updateShippingBar === 'function') {
          window.updateShippingBar(0);
        }
        return;
      }
      let html = '';
      cart.items.forEach(item => {
        const variantHtml = (item.variant_title && item.variant_title !== 'Default Title') ? `<div class="cart-item__variant">${item.variant_title}</div>` : '';
        html += `<div class="cart-item" data-key="${item.key}" data-unit="${item.final_price}">
          <img src="${item.image}" alt="${item.title}" class="cart-item__image" loading="lazy">
          <div class="cart-item__details">
            <a href="${item.url}" class="cart-item__title">${item.product_title}</a>
            ${variantHtml}
            <div class="cart-item__price">${formatMoney(item.line_price)}</div>
            <div class="quantity-stepper">
              <button data-qty-change="-1" data-key="${item.key}">−</button>
              <span class="quantity-stepper__value">${item.quantity}</span>
              <button data-qty-change="1" data-key="${item.key}">+</button>
            </div>
            <button class="cart-item__remove" data-qty-change="0" data-key="${item.key}" data-remove="true">Remove</button>
          </div>
        </div>`;
      });
      body.innerHTML = html;

      const footer = document.querySelector('.cart-subtotal span:last-child') || document.getElementById('cart-subtotal-amount');
      if (footer) { footer.textContent = formatMoney(cart.total_price); footer.dataset.cents = cart.total_price; }
      updateCartCount(cart.item_count);

      // Update shipping progress bar
      if (typeof window.updateShippingBar === 'function') {
        window.updateShippingBar(cart.total_price);
      }

      // Qty change handlers — update qty, line price, subtotal, count & shipping
      // bar INSTANTLY on every click (no button-disabling, so every click
      // registers), then persist to Shopify. Requests are serialised per line and
      // always re-sync to the latest qty, so rapid clicks can't race or get lost.
      const drawerInflight = {};
      const drawerTarget = {};
      async function runDrawerSync(key, itemEl, footerEl) {
        drawerInflight[key] = true;
        try {
          while (true) {
            const qty = drawerTarget[key];
            const res = await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: key, quantity: qty })
            });
            if (!res.ok) throw new Error('Cart change failed: ' + res.status);
            const cart = await res.json();
            if (drawerTarget[key] !== qty) continue;   // more clicks landed — re-sync to the newest value
            if (footerEl) { footerEl.dataset.cents = cart.total_price; footerEl.textContent = formatMoney(cart.total_price); }
            updateCartCount(cart.item_count);
            if (typeof window.updateShippingBar === 'function') window.updateShippingBar(cart.total_price);
            if (qty <= 0) {
              if (itemEl) itemEl.remove();
              if (cart.item_count === 0) loadCartContents();
            } else {
              const it = cart.items.find(i => i.key === key);
              const priceEl2 = itemEl ? itemEl.querySelector('.cart-item__price') : null;
              if (it && priceEl2) priceEl2.textContent = formatMoney(it.line_price);
            }
            break;
          }
        } catch (e) {
          console.error('Cart update failed', e);
          loadCartContents(); // fallback: re-render to a correct state
        } finally {
          drawerInflight[key] = false;
        }
      }
      body.querySelectorAll('[data-qty-change]').forEach(btn => {
        btn.addEventListener('click', () => {
          const itemEl = btn.closest('.cart-item');
          const key = btn.dataset.key;
          const isRemove = btn.dataset.remove === 'true';
          const qtySpan = itemEl ? itemEl.querySelector('.quantity-stepper__value') : null;
          const currentQty = qtySpan ? parseInt(qtySpan.textContent, 10) : 1;
          const newQty = isRemove ? 0 : Math.max(0, currentQty + parseInt(btn.dataset.qtyChange, 10));
          const diff = newQty - currentQty;
          if (diff === 0) return;
          const unit = itemEl ? (parseInt(itemEl.dataset.unit, 10) || 0) : 0;
          const footerEl = document.querySelector('.cart-subtotal span:last-child') || document.getElementById('cart-subtotal-amount');
          const countEl = document.querySelector('[data-cart-count]');
          const curCount = countEl ? (parseInt(countEl.getAttribute('data-cart-count'), 10) || 0) : 0;

          // ---- optimistic (instant) ----
          if (newQty <= 0) {
            if (itemEl) { itemEl.style.opacity = '0.4'; itemEl.style.pointerEvents = 'none'; }
          } else {
            if (qtySpan) qtySpan.textContent = newQty;
            const priceEl = itemEl ? itemEl.querySelector('.cart-item__price') : null;
            if (priceEl) priceEl.textContent = formatMoney(unit * newQty);
          }
          let newTotal = (footerEl ? (parseInt(footerEl.dataset.cents, 10) || 0) : 0) + unit * diff;
          if (newTotal < 0) newTotal = 0;
          if (footerEl) { footerEl.dataset.cents = newTotal; footerEl.textContent = formatMoney(newTotal); }
          updateCartCount(Math.max(0, curCount + diff));
          if (typeof window.updateShippingBar === 'function') window.updateShippingBar(newTotal);

          // ---- persist (serialised per line; re-syncs to the latest qty) ----
          drawerTarget[key] = newQty;
          if (!drawerInflight[key]) runDrawerSync(key, itemEl, footerEl);
        });
      });
    } catch(e) { console.error('Cart load failed', e); }
  }

  function formatMoney(cents) {
    return '₹' + (cents / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function updateCartCount(count) {
    // Mobile badge (.cart-count) — legacy display toggle
    document.querySelectorAll('.cart-count').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'inline-flex' : 'none';
    });

    // Desktop pill badge (.cart-count-inline) — class-driven visibility + bump animation
    document.querySelectorAll('.cart-count-inline').forEach(el => {
      const previous = parseInt(el.dataset.cartCount, 10) || 0;
      el.textContent = count;
      el.dataset.cartCount = String(count);
      el.classList.toggle('is-visible', count > 0);

      // Trigger bump only when count actually increased
      if (count > previous) {
        el.classList.remove('is-bumped');
        // Force reflow so the animation can replay
        void el.offsetWidth;
        el.classList.add('is-bumped');
      }
    });

    // Update aria-label on the cart trigger for screen readers
    document.querySelectorAll('[data-open-cart]').forEach(btn => {
      const label = 'Cart, ' + count + ' item' + (count === 1 ? '' : 's');
      btn.setAttribute('aria-label', label);
    });
  }

  // Expose for quick-view.js and other modules
  window.updateCartCount = updateCartCount;
  window.loadCartContents = loadCartContents;

  /* ================================================
     8. ADD TO CART (product card ATC bar)
     After AJAX add: open cart drawer so user sees their item land
     (matches PDP ATC behaviour and gives feedback that the add worked).
  ================================================ */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-add-to-cart]');
    // Skip if this same element also has data-buy-now (handled below)
    if (!btn || btn.disabled || btn.hasAttribute('data-buy-now')) return;
    const id = btn.dataset.productId;
    if (!id) return;

    e.preventDefault();
    e.stopPropagation();

    const originalText = btn.innerHTML;
    btn.innerHTML = 'Adding…';
    btn.disabled = true;
    // Open the drawer instantly with a loading state (no redundant old-cart fetch).
    if (typeof window.openCartShell === 'function') window.openCartShell();

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id, quantity: 1 })
      });
      if (!res.ok) throw new Error('Failed');
      await res.json();

      // Single fetch to render the updated drawer (also updates the count).
      if (typeof window.loadCartContents === 'function') await window.loadCartContents();

      btn.innerHTML = '✓ Added';
      setTimeout(() => {
        btn.innerHTML = originalText;
        btn.disabled = false;
      }, 1600);
    } catch(e) {
      btn.innerHTML = 'Try Again';
      setTimeout(() => {
        btn.innerHTML = originalText;
        btn.disabled = false;
      }, 2000);
    }
  });

  /* ================================================
     8b. HOMEPAGE / COLLECTION CARD BUY NOW (data-card-buy-now)
     onBuyNowClick crashes outside PDP context, so for cards we just
     AJAX-add the variant and navigate to /checkout. GoKwik's URL
     interceptor catches /checkout (same as it does for anchor clicks
     from the cart drawer on the live theme) and opens its overlay.
     If GoKwik fails to intercept → user lands on Shopify native
     checkout (still completes purchase, just no GoKwik overlay).
  ================================================ */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-card-buy-now]');
    if (!btn || btn.disabled) return;
    const id = btn.dataset.productId;
    if (!id) return;

    e.preventDefault();
    e.stopPropagation();

    const originalText = btn.innerHTML;
    btn.innerHTML = 'Adding…';
    btn.disabled = true;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id, quantity: 1 })
      });
      if (!res.ok) throw new Error('Failed');
      await res.json();
      // Verify cart cookie commit via /cart.js round-trip
      try {
        await fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json());
      } catch(_) {}
      btn.innerHTML = 'Opening checkout…';
      // Use anchor click to mimic the user's tap — GoKwik's listener
      // intercepts anchor clicks on /checkout (this is exactly how
      // the live theme's cart drawer Checkout link works).
      const a = document.createElement('a');
      a.href = '/checkout';
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
    } catch(err) {
      btn.innerHTML = 'Try Again';
      btn.style.background = '#c0392b';
      setTimeout(() => {
        btn.innerHTML = originalText;
        btn.style.background = '';
        btn.disabled = false;
      }, 2000);
    }
  });

  /* ================================================
     9. PRODUCT PAGE ADD TO CART
  ================================================ */
  const productAtcBtn = document.querySelector('.product-atc-btn');
  const productForm = document.querySelector('.product-form');
  if (productAtcBtn && productForm) {
    productAtcBtn.addEventListener('click', async () => {
      const variantInput = productForm.querySelector('[name="id"]');
      const qtyInput = productForm.querySelector('[name="quantity"]');
      if (!variantInput) return;
      const id = variantInput.value;
      const qty = parseInt(qtyInput?.value || 1);
      const originalText = productAtcBtn.textContent;
      productAtcBtn.textContent = 'Adding…';
      productAtcBtn.disabled = true;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id, quantity: qty })
        });
        if (!res.ok) throw new Error('Failed');
        productAtcBtn.textContent = '✓ Added to Cart';
        productAtcBtn.style.background = '#2a7a4b';
        setTimeout(() => {
          productAtcBtn.textContent = originalText;
          productAtcBtn.style.background = '';
          productAtcBtn.disabled = false;
        }, 2000);
        openCart();
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        updateCartCount(cart.item_count);
      } catch(e) {
        productAtcBtn.textContent = 'Error — Try Again';
        productAtcBtn.style.background = '#c0392b';
        setTimeout(() => {
          productAtcBtn.textContent = originalText;
          productAtcBtn.style.background = '';
          productAtcBtn.disabled = false;
        }, 2000);
      }
    });
  }

  /* ================================================
     9b. NEW PDP FORM (id=product-form) — intercept submit
     so ATC adds via AJAX + opens cart drawer instead of
     Shopify's default redirect to /cart page.
  ================================================ */
  const pdpForm = document.getElementById('product-form');
  const pdpAtcBtn = document.getElementById('pdp-atc-btn');
  if (pdpForm && pdpAtcBtn) {
    pdpForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const fd = new FormData(pdpForm);
      const id = fd.get('id');
      const qty = parseInt(fd.get('quantity') || '1', 10);
      if (!id) return;

      const originalText = pdpAtcBtn.innerHTML;
      pdpAtcBtn.innerHTML = 'Adding…';
      pdpAtcBtn.disabled = true;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: id, quantity: qty })
        });
        if (!res.ok) throw new Error('add failed');
        await res.json();

        // Refresh cart count from /cart.js
        try {
          const cartRes = await fetch('/cart.js', { credentials: 'same-origin' });
          const cart = await cartRes.json();
          updateCartCount(cart.item_count);
        } catch(_) {}

        // Open the cart drawer (same one that has the GoKwik
        // "Proceed to Checkout" button).
        if (typeof openCart === 'function') {
          openCart();
        } else {
          // openCart is local — trigger via the header cart button
          const cartBtn = document.querySelector('.header-cart-btn, [data-cart-trigger], [data-open-cart]');
          if (cartBtn) cartBtn.click();
        }

        pdpAtcBtn.innerHTML = '✓ Added';
        setTimeout(() => {
          pdpAtcBtn.innerHTML = originalText;
          pdpAtcBtn.disabled = false;
        }, 1600);
      } catch(err) {
        pdpAtcBtn.innerHTML = 'Try Again';
        setTimeout(() => {
          pdpAtcBtn.innerHTML = originalText;
          pdpAtcBtn.disabled = false;
        }, 2000);
      }
    });
  }

  /* ================================================
     9c. CARD ATC FORMS — same flow as PDP, but for every product
     card on the page. Uses event delegation so it works for cards
     added dynamically by the bestseller carousel / collection grid.
     Action: intercept submit → AJAX add → open cart drawer (instead
     of Shopify's native /cart redirect). Buy Now button is OUTSIDE
     this form via the gokwik-buy-now snippet — won't be intercepted.
  ================================================ */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-card-cart-form]');
    if (!form) return;
    e.preventDefault();
    const fd = new FormData(form);
    const id = fd.get('id');
    const qty = parseInt(fd.get('quantity') || '1', 10);
    if (!id) return;

    const submitBtn = form.querySelector('button[type=submit]');
    const originalText = submitBtn ? submitBtn.innerHTML : '';
    if (submitBtn) {
      submitBtn.innerHTML = 'Adding…';
      submitBtn.disabled = true;
    }

    // Open the drawer INSTANTLY with a loading state (no waiting on the network).
    if (typeof window.openCartShell === 'function') window.openCartShell();

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: id, quantity: qty })
      });
      if (!res.ok) throw new Error('add failed');
      await res.json();

      // Single fetch to render the updated drawer (also updates the count).
      if (typeof window.loadCartContents === 'function') await window.loadCartContents();

      if (submitBtn) {
        submitBtn.innerHTML = '✓ Added';
        setTimeout(() => {
          submitBtn.innerHTML = originalText;
          submitBtn.disabled = false;
        }, 1600);
      }
    } catch(err) {
      if (submitBtn) {
        submitBtn.innerHTML = 'Try Again';
        setTimeout(() => {
          submitBtn.innerHTML = originalText;
          submitBtn.disabled = false;
        }, 2000);
      }
    }
  });

  /* ================================================
     10. PRODUCT GALLERY THUMBNAILS
  ================================================ */
  const galleryMain = document.querySelector('.product-gallery__main');
  const mainImg = galleryMain?.querySelector('img');
  document.querySelectorAll('.product-gallery__thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      document.querySelectorAll('.product-gallery__thumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      const thumbImg = thumb.querySelector('img');
      if (mainImg && thumbImg) {
        mainImg.style.opacity = '0';
        mainImg.style.transform = 'scale(0.97)';
        setTimeout(() => {
          mainImg.src = thumbImg.src.replace('200x', '900x');
          mainImg.style.opacity = '1';
          mainImg.style.transform = 'scale(1)';
        }, 180);
      }
    });
  });

  /* ================================================
     11. VARIANT SELECTION
  ================================================ */
  document.querySelectorAll('.variant-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const group = btn.closest('.variant-group');
      group?.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const form = document.querySelector('.product-form');
      const variantInput = form?.querySelector('[name="id"]');
      if (variantInput && btn.dataset.variantId) {
        variantInput.value = btn.dataset.variantId;
      }
    });
  });

  /* ================================================
     12. QTY BUTTONS
  ================================================ */
  // Handle both .qty-selector (CSS) and .product-qty__control (liquid) wrappers
  document.querySelectorAll('.qty-selector, .product-qty__control').forEach(sel => {
    const input = sel.querySelector('input[type="number"]');
    if (!input) return;
    sel.querySelectorAll('button').forEach(btn => {
      btn.addEventListener('click', () => {
        const v = parseInt(input.value) || 1;
        const delta = btn.textContent.includes('−') || btn.dataset.action === 'decrease' ? -1 : 1;
        input.value = Math.max(1, v + delta);
      });
    });
  });

  /* ================================================
     13. PRODUCT & TRUST TABS
  ================================================ */
  function initTabs(navSelector, panelSelector) {
    document.querySelectorAll(navSelector).forEach(btn => {
      btn.addEventListener('click', () => {
        const parent = btn.closest('[class*="tab"]') || btn.closest('section') || document;
        parent.querySelectorAll(navSelector).forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        const target = btn.dataset.tab;
        parent.querySelectorAll(panelSelector).forEach(panel => {
          panel.classList.toggle('active', panel.id === 'tab-' + target || panel.dataset.tab === target);
        });
      });
    });
  }
  // Trust tabs handled by inline script in trust-badges.liquid (with image swap)
  // initTabs('.trust-tab-btn', '.trust-tab-panel');
  initTabs('.product-tab-btn', '.product-tab-panel');
  // Legacy aliases used in product page liquid
  initTabs('.tab-btn', '.tab-panel');

  /* ================================================
     14. FEATURED PRODUCTS CAROUSEL ARROWS
  ================================================ */
  /* Transform-based product carousel — no scroll, arrows only */
  document.querySelectorAll('.products-carousel').forEach(carousel => {
    const track = carousel.querySelector('.products-carousel__track');
    const prevBtn = carousel.querySelector('[data-carousel-prev]');
    const nextBtn = carousel.querySelector('[data-carousel-next]');
    const dotsContainer = document.getElementById('carousel-dots');
    if (!track) return;

    let currentIndex = 0;
    const cards = track.querySelectorAll('.product-card');
    const totalCards = cards.length;

    const getVisibleCount = () => {
      if (window.innerWidth <= 640) return 2;
      if (window.innerWidth <= 1024) return 3;
      return 5;
    };

    const getTotalPages = () => Math.max(1, Math.ceil(totalCards / getVisibleCount()));

    // Build dots
    const buildDots = () => {
      if (!dotsContainer) return;
      dotsContainer.innerHTML = '';
      const pages = getTotalPages();
      for (let i = 0; i < pages; i++) {
        const dot = document.createElement('button');
        dot.className = 'carousel-dot' + (i === 0 ? ' active' : '');
        dot.setAttribute('aria-label', 'Page ' + (i + 1));
        dot.addEventListener('click', () => { goTo(i); });
        dotsContainer.appendChild(dot);
      }
    };

    const updateSlide = () => {
      const cardWidth = cards[0] ? cards[0].offsetWidth : 0;
      const offset = currentIndex * cardWidth * getVisibleCount();
      const maxOffset = track.scrollWidth - carousel.querySelector('.products-carousel__viewport').offsetWidth;
      track.style.transform = 'translateX(-' + Math.min(offset, Math.max(0, maxOffset)) + 'px)';

      // Show/hide prev arrow
      if (prevBtn) {
        if (currentIndex > 0) {
          prevBtn.classList.add('is-visible');
        } else {
          prevBtn.classList.remove('is-visible');
        }
      }

      // Update dots
      if (dotsContainer) {
        dotsContainer.querySelectorAll('.carousel-dot').forEach((d, i) => {
          d.classList.toggle('active', i === currentIndex);
        });
      }
    };

    const goTo = (index) => {
      const pages = getTotalPages();
      currentIndex = Math.max(0, Math.min(index, pages - 1));
      updateSlide();
    };

    if (nextBtn) {
      nextBtn.addEventListener('click', () => goTo(currentIndex + 1));
    }
    if (prevBtn) {
      prevBtn.addEventListener('click', () => goTo(currentIndex - 1));
    }

    buildDots();
    window.addEventListener('resize', () => { buildDots(); goTo(0); });
  });

  /* 3D tilt effect removed — using zoom instead (handled in CSS) */

  /* ================================================
     16. BLUR-UP IMAGE LOADING
  ================================================ */
  document.querySelectorAll('img[loading="lazy"]').forEach(img => {
    img.classList.add('lazy-blur');
    if (img.complete) {
      img.classList.add('img-loaded');
    } else {
      img.addEventListener('load', () => img.classList.add('img-loaded'));
    }
  });

  /* ================================================
     17. COUNT-UP ANIMATION
  ================================================ */
  const countUpIO = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const el = entry.target;
      const target = parseFloat(el.dataset.target);
      const suffix = el.dataset.suffix || '';
      const duration = 1800;
      const start = performance.now();
      countUpIO.unobserve(el);

      const step = (now) => {
        const progress = Math.min((now - start) / duration, 1);
        const ease = 1 - Math.pow(1 - progress, 3);
        const raw = target < 10 ? (target * ease).toFixed(1) : Math.round(target * ease);
        const val = target >= 1000 ? Number(raw).toLocaleString() : raw;
        el.textContent = val + suffix;
        if (progress < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    });
  }, { threshold: 0.5 });

  document.querySelectorAll('[data-count-up]').forEach(el => countUpIO.observe(el));

  /* ================================================
     18. HERO PARALLAX
  ================================================ */
  const heroMedia = document.querySelector('.hero-banner__media img');
  if (heroMedia) {
    window.addEventListener('scroll', () => {
      const scrolled = window.scrollY;
      if (scrolled < window.innerHeight) {
        heroMedia.style.transform = `translateY(${scrolled * 0.18}px)`;
      }
    }, { passive: true });
  }

  /* ================================================
     19. SMOOTH SCROLL for anchor links
  ================================================ */
  document.querySelectorAll('a[href^="#"]').forEach(link => {
    link.addEventListener('click', (e) => {
      const target = document.querySelector(link.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* ================================================
     20. LOAD CART COUNT ON INIT
  ================================================ */
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => updateCartCount(cart.item_count))
    .catch(() => {});

});
